import { CurrencyModel } from 'models/Settings/Financial/CurrencyModel';
import { ReservationCardGroupModel } from 'pages/ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export enum CurrencyApplicationEnum {
  FIXED = 'fixed',
  DAILY = 'daily',
}

export enum DateTypeEnum {
  DEPARTURE_DATE = 'departure_date',
  BOOKING_DATE = 'booking_date',
  INSERT_DATE = 'insert_date',
  CANCELLATION_DATE = 'cancellation_date',
  // ARRIVAL_DATE = 'arrival_date',
}

export interface ReservationListReportFormModel {
  from: string | null;
  to: string | null;
  company: ReservationCardGroupModel | null;
  rates: Array<number>;
  roomType: number | null;
  states?: Array<number>;
  with_revenue: boolean;
  currency: CurrencyModel | null;
  currency_application: CurrencyApplicationEnum | null;
  fixed_at: string | null;
  date_type: DateTypeEnum;
  gross_revenue: boolean;
  file_type: exportFileTypes;
}
